/**
 * @generated SignedSource<<fc823e1dcba1f5704bf591f9f921df7f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ShoppingWithWrapper_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"AllShoppersModal_viewer" | "ShoppingWithGrid_viewer">;
  readonly " $fragmentType": "ShoppingWithWrapper_viewer";
};
export type ShoppingWithWrapper_viewer$key = {
  readonly " $data"?: ShoppingWithWrapper_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"ShoppingWithWrapper_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ShoppingWithWrapper_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "AllShoppersModal_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ShoppingWithGrid_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "6426930c72d7451ac9da7b9482f762bd";

export default node;
